// @flow

import * as React from 'react';
import CurrencyPicker from './pickers/CurrencyPicker';
import PosPicker from './pickers/PosPicker';
import styles from './PickerSection.less';
import type { CurrencyPreview, PosPreview } from './pickers/types';

type Props = {
  currencyPreview: CurrencyPreview,
  posPreview: PosPreview,
};

/** Wrapper for the pickers */
const PickerSection = ({ currencyPreview, posPreview }: Props) => (
  <div>
    <div className={styles.pickerEntrypointWrap}>
      <CurrencyPicker currencyPreview={currencyPreview} />
    </div>

    <div className={styles.pickerEntrypointWrap}>
      <PosPicker posPreview={posPreview} />
    </div>
  </div>
);

export default PickerSection;
